import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cog-button" }
const _hoisted_2 = { class: "p-menu p-component p-menu-overlay p-1" }
const _hoisted_3 = {
  key: 2,
  class: "inline-flex"
}

import { ref, watch } from 'vue';
import OverlayPanel from 'primevue/overlaypanel';
import { rrulestr } from 'rrule';
import { useDateTime } from '@/composables';
import { useCalendarStore, useEventsModalsStore, useTherapyStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditEventOverlayPanel',
  setup(__props) {

const op = ref<OverlayPanel>();
const eventId = ref<number>(0);
const eventTimes = ref<Record<string, Date | string>[]>([]);
const selectedEventDate = ref<Date | null>(null);
const calendarStore = useCalendarStore();
const eventsModalsStore = useEventsModalsStore();
const therapyStore = useTherapyStore();

const toggleOverlayPanel = (toggle: Event | boolean) => op.value?.toggle(toggle);

const onSearchEvent = async () => {
  const calendarStore = useCalendarStore();
  await calendarStore.getEvent(eventId.value.toString());
  eventsModalsStore.eventToDocumentOrEdit = calendarStore.selectedEvent;

  if (!eventsModalsStore.eventToDocumentOrEdit.rrule) {
    selectedEventDate.value = new Date(calendarStore.selectedEvent.start_at);
  } else {
    const rruleObject = rrulestr(eventsModalsStore.eventToDocumentOrEdit.rrule);
    const eventDates = rruleObject.between(new Date(new Date().setHours(-1440)), new Date(new Date().setHours(1440)));

    eventTimes.value = eventDates.map((date) => ({ label: date.toDateString(), value: date }));
  }
};

watch(selectedEventDate, () => {
  if (!selectedEventDate.value) return;

  const startingHours = useDateTime().fromUTCStringToLocalDate(calendarStore.selectedEvent.start_at).getHours();
  const startingDateObject = useDateTime()
    .fromUTCStringToLocalDate(useDateTime().formatDateForApi(selectedEventDate.value, true))
    .setHours(startingHours);
  const endingDateObject = useDateTime().fromUTCStringToLocalDate(calendarStore.selectedEvent.end_at);

  calendarStore.selectedEvent.start_at = new Date(startingDateObject).toString();
  calendarStore.selectedEvent.end_at = new Date(endingDateObject).toString();

  eventsModalsStore.clickedEventClickArgs = {
    id: calendarStore.selectedEvent.id as number,
    start: calendarStore.selectedEvent.start_at,
    startStr: useDateTime().formatDateToLocalISOString(new Date(endingDateObject)),
    end: calendarStore.selectedEvent.end_at,
  };

  eventsModalsStore.eventToEditSelected = true;
  eventsModalsStore.preselectedEventType = eventsModalsStore.eventToDocumentOrEdit?.therapy_event_type;
});

const editEvent = () => {
  toggleOverlayPanel(false);
  eventsModalsStore.toggleEventModal();
};

const unlockEvent = async () => {
  toggleOverlayPanel(false);
  await therapyStore.unlockEvent(calendarStore.selectedEvent.id);
};

const resetValues = () => {
  eventTimes.value = [];
  eventId.value = 0;
  selectedEventDate.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "edit-event-overlay-panel-container mr-3",
    onClick: toggleOverlayPanel
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_Icon, {
        name: "settings",
        class: "text-color-primary cursor-pointer"
      })
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op,
      onHide: resetValues
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "p-menuitem-content" }, "Enter the event id you would like to edit or unlock:", -1)),
          _createVNode(_component_InputNumber, {
            modelValue: eventId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((eventId).value = $event)),
            "use-grouping": false
          }, null, 8, ["modelValue"]),
          (eventTimes.value.length)
            ? (_openBlock(), _createBlock(_component_Dropdown, {
                key: 0,
                id: "event_times",
                modelValue: selectedEventDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedEventDate).value = $event)),
                "option-label": "label",
                "option-value": "value",
                options: eventTimes.value,
                placeholder: "Select the event date"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (!selectedEventDate.value)
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 1,
                text: 'Search',
                type: "primary",
                disabled: !eventId.value,
                onClick: onSearchEvent
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (selectedEventDate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_AppButton, {
                  text: "Edit Event",
                  type: "primary",
                  onClick: editEvent
                }),
                _createVNode(_component_AppButton, {
                  text: "Unlock",
                  type: "primary",
                  disabled: !_unref(calendarStore).selectedEvent?.is_locked,
                  onClick: unlockEvent
                }, null, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})